import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import ListSubheader from '@material-ui/core/ListSubheader';
import style from "./ListTitle.style";

const ListTitle = ({
  children,
  component,
  testID,
  title,
  className
}) => ___EmotionJSX(ListSubheader, {
  className: className,
  css: style.container.base,
  component: component,
  id: testID
}, ___EmotionJSX("span", {
  css: style.title.base
}, title), children);

ListTitle.defaultProps = {
  title: '',
  children: [],
  component: 'li',
  testID: undefined,
  className: null
};
ListTitle.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  component: PropTypes.string,
  testID: PropTypes.string,
  className: PropTypes.string
};
export default React.memo(ListTitle);